import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { editorRoutes, journalRoutes, publicRoutes, readerRoutes, teacherRoutes } from "../routes";
import { START_ROUTE } from "../utils/consts/pathRoutes";
import { getUserRole, hasContingentAccess, hasJournalAccess, isTeacher, landingRoute, ROLES } from "../utils/consts/roles";
import { useSelector } from "react-redux";
import { getAppStatus } from "../store/slices/AppData/selectors";
import Spinner from "./common/Spinner";

const AppRouter = () => {
  const userRole = getUserRole();
  const appStatus = useSelector(getAppStatus);

  // Проверки положительные: роль получает маршруты, только если явно перечислена.
  // При проверке «от обратного» новая роль молча получала бы весь контингент.
  const contingentAccess = hasContingentAccess(userRole);
  const editorAccess = userRole === ROLES.ADMIN || userRole === ROLES.EDITOR;
  const teacherAccess = isTeacher(userRole);
  const journalAccess = hasJournalAccess(userRole);

  if (appStatus === 0) {
    return (
      <Spinner />
    );
  }

  // Группы маршрутов пересекаются: личный кабинет есть и у контингента, и у журнала.
  // Собираем один список без повторов, иначе у администратора было бы два Route с одним ключом.
  const allowed = [
    ...(contingentAccess ? readerRoutes : []),
    ...(editorAccess ? editorRoutes : []),
    ...(teacherAccess ? teacherRoutes : []),
    ...(journalAccess ? journalRoutes : []),
    ...publicRoutes,
  ].filter((route, index, list) => list.findIndex((item) => item.path === route.path) === index);

  return (
    <Routes>
      {allowed.map(({ path, Component }) =>
        <Route key={path} path={path} element={<Component />} exact />
      )}
      {/* Авторизованного уводим на его раздел, а не на страницу входа:
          у роли журнала нет доступа к контингенту, и общий '/' для неё пустой. */}
      <Route path="*" element={<Navigate to={userRole === ROLES.UNAUTHORIZED ? START_ROUTE : landingRoute(userRole)} replace />} />
    </Routes>
  );
};

export default AppRouter;